<script lang="ts" setup>
const props = defineProps<{ data: Review, isOpen?: boolean, isUsersItem?: boolean }>()
const { userId, user } = useUser()
</script>

<template>
  <div class="flex flex-col gap-3">
    <UICard class="overflow-clip relative text-blue font-semibold">
      <CollectionReviewHide
        v-if="isUsersItem"
        :id="data.id"
        :visible="data.visible"
        class="self-end"
      />
      <div class="relative flex flex-col h-full pt-2 justify-center">
        <p class="md:text-lg lg:text-xl pt-3 flex">
          {{ data.review }}
        </p>

        <div class="flex flex-wrap gap-6 justify-between items-center pt-6 ">
          <div class="flex justify-end gap-6 items-center">
            <div class="flex flex-col">
              <p>
                {{ data.reviewer === userId ? user?.name : data.reviewer }}
              </p>
            </div>
            <div
              class=" rounded-full overflow-clip flex items-center justify-center shadow-lg bg-blue h-8 w-8"
            >
              <UIcon
                name="heroicons:user-20-solid"
                class="w-8 h-8 text-white bg-white"
              />
            </div>
          </div>
        </div>
      </div>
    </UICard>
  </div>
</template>
